import { ClinicFormInfoDto } from '../generated';
import { Clinic } from '../model/Clinic';
import { parseDiagnosis } from './diagnosis.parser';

export const parseClinic = (data: ClinicFormInfoDto): Clinic => {
  return {
    name: data.name,
    goals: data.goals,
    diagnoses: data.diagnoses.map(parseDiagnosis)
  };
};
